module.exports = __webpack_public_path__ + "img/distribucion.d44e8e26.png";